import { createContext, useState } from "react";
import type { IPartnersContextData, IPartnersProviderProps } from "./types";
import { createPartnersUtils } from "./utils";
import Loading from "../../components/Shared/Loading";

export const PartnersContext = createContext<IPartnersContextData | null>(null);

export const PartnersProvider = ({ children }: IPartnersProviderProps) => {
  const [isLoading, _setIsLoading] = useState(false);

  const contextValue: IPartnersContextData = {
    ...createPartnersUtils(),
  };

  return (
    <PartnersContext.Provider value={contextValue}>
      {isLoading && <Loading />}
      {children}
    </PartnersContext.Provider>
  );
};
